import React from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './BackButton.module.css'
import BackIcon from 'Icons/arrow-left.svg'

const BackButton = (props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate('../')
  }

  return (
    <div className={styles.Container} {...props} onClick={handleClick}>
      <BackIcon width='20' height='20' />
      <span className={styles.Text}>Back</span>
    </div>
  )
}

export default BackButton
